<template>
    <div>

    </div>
</template>

<script>

    import { triggerWindowResizeEvent } from '@/utils/web-utils';
    import { updateTheme, updateColorWeak, colorList } from '@/components/tools/setting'

    export default {
        name: "Index",
        created() {
            this.pageInit();
        },
        inject:['setHeaderShowType', 'setHeaderIsShow', 'setFooterIsShow'],                                  //调用父亲方法
        methods: {
            pageInit: function () {
                //console.log('MI PageInit...');
                let that = this;
                this.$nextTick(function () {
                    that.setHeaderShowType(2, window._CONFIG['moduleGroup']);
                    that.setHeaderIsShow(true);
                });
            },
        },
    }
</script>

<style scoped>

</style>
